export enum QuoteStatus {
    Active = 'active',
    Expired = 'expired',
}
